<template>
  <div>
    <v-dialog
      v-model="showModal"
      persistent
      fullscreen
    >
      <div class="content-section">
        <br>
        <h1 class="header-style">
          Review Image
        </h1>
        <br>
        <v-row>
          <v-col
            cols="12"
          >
            <v-img
              class="image-preview"
              :src="imageUrl"
              alt=""
            />
          </v-col>
        </v-row>
        <br>
        <br>
        <br>
        <v-btn
          fab
          color="#FFF"
          small
          rounded
          elevation="0"
          class="close-button"
          @click="closeModal()"
        >
          <v-icon color="#37474f">
            mdi mdi-close
          </v-icon>
        </v-btn>
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-text-field
            v-model="comment"
            class="chat-text-style"
            outlined
            dense
            background-color="#FFFFFF"
            light
            color="#37474f"
            placeholder="Add comment"
          >
            <template slot="append">
              <v-btn
                fab
                small
                elevation="0"
                color="transparent"
                @click="addComment()"
              >
                <v-icon color="#929292">
                  mdi-send
                </v-icon>
              </v-btn>
            </template>
          </v-text-field>
        </v-form>
      </div>
    </v-dialog>
    <centre-spinner :loading="loading" />
  </div>
</template>

<script>
import spinner from 'src/views/components/SpinnerCentre';
export default {
  name: 'ReviewImageDialog',
  components: {
    'centre-spinner': spinner,
  },
  data: () => ({
    showModal: true,
    imageUrl: null,
    loading: false,
    valid: false,
    comment: '',
  }),
  computed: {
    selectedFiles () {
        return this.$store.getters['jobs/getSelectedFiles'];
    },
    firstOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
  },
  watch: {
    showModal: function (newval, oldval) {
      if (newval === false) {
        this.$store.dispatch('jobs/clearSelectedFiles');
        this.$emit('closed');
      }
    },
    selectedFiles: {
      handler (newFiles) {
        if (newFiles) {
          this.imageUrl = URL.createObjectURL(newFiles);
        }
      },
      immediate: true,
    },
  },
  methods: {
    closeModal () {
      this.$store.dispatch('jobs/clearSelectedFiles');
      this.showModal = false;
    },
    async addComment () {
      this.loading = true;
      const jobId = this.$route.params.jobId;
      const file = this.selectedFiles;

      const formData = new FormData();
      formData.append('comment', this.comment);
      formData.append('document_file', file);

      await this.$store.dispatch('jobs/addComment', {
        formData: formData,
        jobId: jobId,
        orgId: this.firstOrganization.organization.external_id,
      }).then(response => {
        this.comment = '';
        this.$emit('reviewed-image');
        this.showModal = false;
        this.loading = false;
        }).catch(errors => {
          this.loading = false;
      });
    },
  },
};
</script>

<style scoped>
.image-preview {
  width: 100% !important;
  border-radius: 10px;
}

.add-more-image {
  width: 100%;
  height: 150px !important;
  border-radius: 10px;
  background: #CCC;
  display: flex;
  justify-content: center;
  align-items: center;
}

.chat-text-style {
  position: fixed;
  width: 90%;
  bottom: 0;
}

.v-text-field--enclosed >>> .v-input__append-inner {
  margin-top: 5px !important;
  margin-bottom: 5px !important;
}
</style>
